import {
  AppBar,
  Box,
  Container,
  darken,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  Toolbar,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Link from "next/link";
import React, { useRef } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import { useRouter } from "next/router";
import { MdRestaurantMenu, MdRoomService, MdEmail } from "react-icons/md";
import { BsFacebook } from "react-icons/bs";

interface IRoute {
  href: string;
  title: string;
  icon?: JSX.Element;
}

const routes: IRoute[] = [
  { href: "/#sluzby", title: "Služby", icon: <MdRoomService size={22} /> },
  { href: "/nabidka", title: "Nabídka", icon: <MdRestaurantMenu size={22} /> },
  { href: "/#kontakt", title: "Kontakt", icon: <MdEmail size={22} /> },
];

const NavBar: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const buttonAnchor = useRef(null);

  const router = useRouter();

  const {
    palette: { mode },
  } = useTheme();

  const toggleNav = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleNav = (href: string) => () => {
    setDrawerOpen(false);
    router.push(href);
  };

  return (
    <React.Fragment>
      <AppBar
        position="fixed"
        sx={(theme) => ({
          backgroundColor: theme.palette.background.default,
          color: theme.palette.primary.main,
          zIndex: theme.zIndex.drawer + 1,
        })}
      >
        <Container>
          <Toolbar>
            <Box>
              <Link href="/" passHref>
                <Typography
                  variant="h6"
                  component="div"
                  //color={mode === "light" ? "primary" : "white"}
                  sx={(theme) => ({
                    cursor: "pointer",
                    ...(theme.palette.mode === "light" && {
                      color: darken(theme.palette.primary.main, 1),
                    }),
                    [theme.breakpoints.down("sm")]: { fontSize: 18 },
                  })}
                >
                  Pivovarská restaurace Čáslav
                </Typography>
              </Link>
            </Box>
            <Box sx={{ flexGrow: 1 }} />
            <Box
              sx={(theme) => ({
                [theme.breakpoints.down("sm")]: {
                  display: "none",
                },
                display: "flex",
                gap: theme.spacing(4),
                "& > a": {
                  color:
                    theme.palette.mode === "dark"
                      ? "white"
                      : "#3b3b3b !important",
                  transition: "color 0.2s",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",

                  "&:hover": {
                    color:
                      theme.palette.mode === "dark"
                        ? "#b6b6b6 !important"
                        : "#818181 !important",
                  },
                },
              })}
            >
              {routes.map((route) => (
                <Link href={route.href} key={route.href} passHref>
                  <Box
                    sx={{
                      marginRight: 1,
                      fontSize: 18,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {route.icon}
                  </Box>
                  {route.title}
                </Link>
              ))}
              <Tooltip title={<Typography>Facebook</Typography>}>
                <a
                  href="https://www.facebook.com/pivovarcaslav"
                  target="_blank"
                  rel="noreferrer"
                >
                  <IconButton size="medium" aria-label="Facebooková stránka">
                    <BsFacebook
                      size={22}
                      color={mode === "dark" ? "white" : "#3b3b3b"}
                    />
                  </IconButton>
                </a>
              </Tooltip>
            </Box>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              ref={buttonAnchor}
              sx={(theme) => ({
                ml: 2,
                [theme.breakpoints.up("sm")]: { display: "none" },
              })}
              onClick={toggleNav}
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>
      {/* @ts-ignore */}
      <SwipeableDrawer
        anchor="top"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        onOpen={() => setDrawerOpen(true)}
      >
        <div>
          <Toolbar />
          <List>
            {routes.map((route) => (
              <ListItem key={route.href}>
                <ListItemButton onClick={handleNav(route.href)}>
                  <Box sx={{ marginRight: 2, fontSize: 18 }}>{route.icon}</Box>
                  {route.title}
                </ListItemButton>
              </ListItem>
            ))}
            <a
              href="https://www.facebook.com/pivovarcaslav"
              target="_blank"
              rel="noreferrer"
            >
              <ListItem>
                <ListItemButton>
                  <Box sx={{ marginRight: 2, fontSize: 18 }}>
                    <BsFacebook size={22} />
                  </Box>
                  Facebook
                </ListItemButton>
              </ListItem>
            </a>
          </List>
        </div>
      </SwipeableDrawer>
    </React.Fragment>
  );
};

export default NavBar;
